import { signal } from "@preact/signals-core";

const COMPANY_ID_KEY = "owlishbean.companyId";

export interface CurrentUser {
  id: string;
  email: string;
}

function readStoredCompanyId(): string | null {
  try {
    return localStorage.getItem(COMPANY_ID_KEY);
  } catch {
    return null;
  }
}

export const session = {
  user: signal<CurrentUser | null>(null),
  csrfToken: signal<string | null>(null),
  companyId: signal<string | null>(readStoredCompanyId()),

  clear(): void {
    session.user.value = null;
    session.csrfToken.value = null;
  },

  setCompanyId(id: string): void {
    session.companyId.value = id;
    try {
      localStorage.setItem(COMPANY_ID_KEY, id);
    } catch {
      // localStorage unavailable (private browsing etc.) — company switcher just won't persist
    }
  },
};
